import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {Filter, SimpleUnit} from '@core/interfaces/system/system-common';
import {FaultIndicationDashboardData, LatestModelStatus, RowDataReadingsDashboardData} from './live';

export interface OilTemperatureVsMoistureUnits {
    oilTemperatureUnit: SimpleUnit;
    oilMoistureUnit: SimpleUnit;
    paperMoistureUnit: SimpleUnit;
}

export abstract class OilTemperatureMoistureService {
    abstract getOilTemperatureVsMoistureUnits(): Observable<OilTemperatureVsMoistureUnits>;

    abstract getOilTemperatureVsMoistureDatasource(id: string, filter: Filter[]): Observable<DataSource>;

    abstract getCountResults(id: string, uploadTime?: string): Observable<number>;

    abstract getOilTemperatureVsMoistureLatestModelStatus(
        id: string,
        uploadTime?: string,
    ): Observable<LatestModelStatus>;

    abstract getOilRowDataReadingsDashboardData(
        id: string,
        uploadTime?: string,
    ): Observable<RowDataReadingsDashboardData>;

    abstract getOilFaultIndicationDashboardData(
        id: string,
        uploadTime?: string,
    ): Observable<FaultIndicationDashboardData>;
}
